export default __webpack_public_path__ + "static/media/HL21.e69a0e72.png";